<template>
	<Col>
		<Col :class="{ 'mt-2': i !== 0 }" v-for="(section, i) in sections" :key="`section_${i}`">
			<template v-if="getItems(section.getItemsFunc).length > 0">
				<h5 class="section-title ml-5" v-if="section.title">{{ section.title }}</h5>
				<NavigationAccordionButton
					v-for="item in getItems(section.getItemsFunc)"
					class="mt-1"
					:key="item.id"
					:itemId="item.id"
					:name="item.name"
					:settings="settings"
					:icon="item.icon_name"
					:to="routerLinkTo(item)"
					:localIcon="item.localIcon"
					@click.native="$emit('item-clicked')"
					:billingFeatureId="item.billingFeatureId"
					:additionalItemSuffix="additionalItemSuffix"
				/>
			</template>
		</Col>
	</Col>
</template>
<script>
import NavigationAccordionButton from './NavigationAccordionButton';
export default {
	name: 'NavigationAccordionContent',
	props: {
		to: { type: Function },
		sections: { type: Array },
		settings: { type: Object },
		scrollable: { type: Boolean },
		additionalItemSuffix: { type: Object },
	},
	components: { NavigationAccordionButton },
	methods: {
		getItems(getItemsFunc) {
			return getItemsFunc();
		},
		routerLinkTo(item) {
			return this.to({ id: item.id });
		},
	},
};
</script>
<style lang="scss" scoped>
.section-title {
	font-size: 11px;
	color: #8f95ab;
	font-weight: normal;
}
</style>
